import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import { RootState } from '../redux/store';
import { RouteComponentProps, withRouter } from 'react-router';
import Select from 'react-select';
import { useForm } from 'react-hook-form';
import 'antd/dist/antd.css';
import { addedGroup, startAddingGroup, startUpdatingGroup, updatedGroup } from '../redux/actions';
import { addGroup, updateGroup } from '../utils/api';
import Alert from 'react-bootstrap/Alert';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

interface Props {
  error: boolean;
  message: string;
  loading: boolean;
}
interface DispatchProps {
  startAddingGroup: () => void;
  addedGroup: (
    groupId: string,
    actions: string[],
    message: string,
    error: boolean,
  ) => {
    type: string;
    payload: {
      groupId: string;
      actions: string[];
      message: string;
      error: boolean;
    };
  };
  startUpdatingGroup: () => void;
  updatedGroup: (
    groupId: string,
    actions: string[],
    message: string,
    error: boolean,
  ) => {
    type: string;
    payload: {
      groupId: string;
      actions: string[],
      message: string;
      error: boolean;
    };
  };
}

type ComposedProps = Props & DispatchProps & RouteComponentProps<{ id: string }>;

const GroupForm = (props: ComposedProps): JSX.Element => {
  const selectRef = useRef<any>([]);
  //const { permissions } = useAppSelector((state) => state.permissions);
  const { groups } = useAppSelector((state) => state.groups);
  const groupToEdit =
    props.match.params.id !== 'add' && groups ? groups.filter((item: any) => item.groupId === props.match.params.id) : null;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      groupId: groupToEdit ? groupToEdit[0]?.groupId : null,
    },
  });

  const id = props.match.params.id;

  const [submitting, setSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(false);
  const [isDisabledId, setisDisabledId] = useState<boolean>(false);

  const permissionsSelect = () => {
    let list : any[] = [];
    (groups || []).map((g: { groupId: string; actions: never[]; }) => {
      if(g.groupId === 'ALL_PERMISSIONS_GROUP'){
        (g.actions || []).map(a =>{
          list.push({label:a,value:a})
        })
      } 
    })
    return list;
  }

  const prms = () => {
    let array: any[] = [];
    let p = groupToEdit[0]?.actions;
    (p || []).map(item=>{
      array.push({label:item, value:item});
    })
    return array;
  }

  const [permissionsValues, setPermissionsValues] = useState<string[]>(groupToEdit && groupToEdit[0] && groupToEdit[0]?.actions ? prms() : permissionsSelect()[0]);

  const onSubmit = async (data) => {
    setSubmitting(true);
    setShowAlert(false);
    props.startAddingGroup();
    let array: any[] = [];
    array.push(permissionsValues)
    let pv: any[] = [];
    if(permissionsValues.length===undefined){
      pv.push(array[0].value);
    }else{
      pv = permissionsValues
    }
    if(pv?.length > 0){
      addGroup(data.groupId, pv)
        .then((response) => {
          props.addedGroup(data.groupId, pv, 'Started group add', false);
          setValue('groupId', null);
          if (selectRef !== null && selectRef.current !== null) {
            //selectRef.current.clearValue()
            setPermissionsValues(permissionsSelect()[0])
          }
          setShowAlert(true);
          setSubmitting(false);
          setError(false);
        })
        .catch((error) => {
          props.addedGroup(data.groupId, pv, 'Failed to add group', true);
          setShowAlert(true);
          setSubmitting(false);
          console.log(error);
          setError(true);
        });
    }
  };

  /**
   * send a put request to update edited data
   * @param data the data passed through form fields
   */
  const onUpdate = async (data) => {
    
    setSubmitting(true);
    setShowAlert(false);

    let stop = false;
    let array: any[] = [];
    let pv: any[] = [];
    (permissionsValues || []).map(item=>{
      array.push(item);
    });
    !stop && (array || []).map(item=>{
      if(item.value!==undefined){
        pv.push(item.value);
      }else{
        pv = permissionsValues
        stop = true;
      }
    })
    if(pv?.length > 0){
      updateGroup(data.groupId, pv)
        .then((response) => {
          props.updatedGroup(
            data.grouId,
            pv,
            'Started group update',
            false,
          );
          setShowAlert(true);
          setSubmitting(false);
          setError(false);
        })
        .catch((error) => {
          props.updatedGroup(
            data.grouId,
            pv,
            'Failed to update group',
            true,
          );
          setShowAlert(true);
          setSubmitting(false);
          setError(true);
        });
    }
};

  /**
   * handle action on submitting. If user try to add new podcast calls [onSubmit] else [onUpdate] functions
   * @param data the data passed through form fields
   */
  const onSubmitActionHandler = async (data) => {
    if (id === 'add') {
      await onSubmit(data);
    } else {
      await onUpdate(data);
      setShowAlert(true);
    }
  };

  const onSelectChange = (e) => {
    let array : string[] = [];
    (e || []).map(g=>{
      array.push(g.value)   
    })
    setPermissionsValues(array)
  }

  const alertVariant = error ? 'danger' : 'success';

  const alertMessage = error ? 'Failed to add group.' : 'Group added.';
  const alertUpdateMessage = error ? 'Failed to update group.' : 'Group updated.';

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (id !== 'add') {
      setisDisabledId(true);
    }
  }, []);

  return (
    <div>
      {showAlert && (
        <Alert variant={alertVariant} dismissible onClose={() => setShowAlert(false)}>
          {id === 'add' ? alertMessage : alertUpdateMessage}
        </Alert>
      )}
      <div className="w-full border mx-auto p-4">
        <form onSubmit={handleSubmit(onSubmitActionHandler)}>
          <div className="mb-4">
            <h2 className="text-4xl font-medium leading-tight mt-0 text-black-600">
              {id === 'add' ? 'Add a group' : `Edit ${id} group`}
            </h2>
          </div>
          <div className="flex items-center mb-6">
            <div className="width-fix">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Group ID:</label>
            </div>
            <div>
              <input
                disabled={submitting || isDisabledId}
                className="appearance-none border border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                type="text"
                {...register('groupId', { required: true, pattern: /^[a-zA-Z0-9]+$/gi })}
              />
              {errors.groupId?.type === 'required' && <div className="text-red-500 text-left">This field is required</div>}
              {errors.groupId?.type === "pattern" && <div className="text-red-500 text-left">Enter only alphanumeric characters</div> }
            </div>
          </div>
          <div className="flex items-center mb-6">
            <div className="width-fix">
              <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">Permissions:</label>
            </div>
            <div style={{width:'250px'}}>
              <Select
                ref={selectRef}
                isMulti
                onChange={onSelectChange}
                options={permissionsSelect()}
                placeholder=''
                closeMenuOnSelect={false}
                defaultValue={permissionsValues}
              />
              {permissionsValues?.length === 0 && <div className="text-red-500 text-left">This field is required</div>}
            </div>
          </div>

          <div className="flex items-center">
            <div className="">
              <button
                disabled={submitting}
                type="submit"
                className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
              >
                {id === 'add' ? 'Add Group' : 'Update Group'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    error: state.podcasts.error,
    message: state.podcasts.message,
    loading: state.podcasts.loading,
  };
};

const dispatchToProps: DispatchProps = {
  startAddingGroup,
  addedGroup,
  startUpdatingGroup,
  updatedGroup,
};

export default connect(mapStateToProps, dispatchToProps)(withRouter(GroupForm));
